import { render, staticRenderFns } from "./AllTabs.vue?vue&type=template&id=12470eb1"
import script from "./AllTabs.vue?vue&type=script&lang=js"
export * from "./AllTabs.vue?vue&type=script&lang=js"
import style0 from "./AllTabs.vue?vue&type=style&index=0&id=12470eb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports